export default __webpack_public_path__ + "static/media/exam-prep-figure.c6432f2e.svg";